import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import { API } from "./../../config/api";

export default function MyOrders() {
  useEffect(() => {
    document.title = "Orders";
  }, []);
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "My Orders",
      link: "/myorders",
    },
  ];
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [user, setUser] = useState(null);
  // Get user data from sessionStorage safely
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        setUser(null);
      }
    }
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  // 1. Memoized fetch function to prevent unnecessary re-renders
  const fetchOrders = useCallback(() => {
    if (user?.id) {
      fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/OrderList?userid=${user.id}`,
      )
        .then((res) => {
          if (!res.ok) throw new Error("Network error");
          return res.json();
        })
        .then((data) => {
          if (data?.success && Array.isArray(data.data)) {
            setOrders(data.data);
          } else {
            setOrders([]);
          }
        })
        .catch((err) => console.error("Fetch error:", err));
    }
  }, [user?.id]);

  // 2. Manage the Auto-Update Lifecycle
  useEffect(() => {
    // Initial fetch on component mount
    fetchOrders();

    // Set interval for refreshing data every 10 seconds
    const intervalId = setInterval(() => {
      fetchOrders();
    }, 10000);

    // CLEANUP: Important! Stops the timer when user leaves the page
    return () => clearInterval(intervalId);
  }, [fetchOrders]);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const totalPages = Math.ceil(orders.length / itemsPerPage) || 1;

  const safePage = Math.min(currentPage, totalPages);

  const indexOfLastItem = safePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentOrders = orders.slice(indexOfFirstItem, indexOfLastItem);

  const goToPage = (page) => {
    setCurrentPage(page);
    scrollToTop();
  };
  const getPagination = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);

      if (safePage > 3) pages.push("...");

      let start = Math.max(2, safePage - 1);
      let end = Math.min(totalPages - 1, safePage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (safePage < totalPages - 2) pages.push("...");

      pages.push(totalPages);
    }

    return pages;
  };
  return (
    <div className="container-fluid m-4">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {breadcrumbItems.map((item, i) => (
            <li
              key={i}
              className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
            >
              {i === breadcrumbItems.length - 1 ? (
                item.label
              ) : (
                <a href={item.link}>{item.label}</a>
              )}
            </li>
          ))}
        </ol>
      </nav>

      <div className="d-flex justify-content-between align-items-center mb-3 ms-3">
        <h3 className="fw-bold">Order List</h3>
        {/* <div className="badge bg-light text-muted border px-3 py-2">
          <i className="bi bi-arrow-repeat me-1"></i> Auto-updating
        </div> */}
      </div>

      <div className="table-responsive bg-white shadow-sm rounded">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-primary">
            <tr>
              <th className="ps-3">Order No.</th>
              <th>Date</th>
              <th>Time</th>
              <th>Total_Amount</th>
              <th>Status</th>
              <th className="text-center pe-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {!user ? (
              <tr>
                <td colSpan="6" className="text-center py-5">
                  <div className="mb-2 fs-1">🔒</div>

                  <h5 className="fw-bold text-danger">Please login first</h5>

                  <p className="text-muted mb-3">
                    You need to login to view your orders
                  </p>

                  <button
                    className="btn btn-primary px-5 py-2 mt-2 fw-bold"
                    onClick={() => setShowLogin(true)}
                  >
                    Login Now
                  </button>

                  <Login
                    isOpen={showLogin}
                    onClose={() => setShowLogin(false)}
                    openRegister={() => {
                      setShowLogin(false);
                      setShowRegister(true);
                    }}
                  />
                  <Register
                    isOpen={showRegister}
                    onClose={() => setShowRegister(false)}
                    openLogin={() => {
                      setShowRegister(false);
                      setShowLogin(true);
                    }}
                  />
                </td>
              </tr>
            ) : orders.length > 0 ? (
              currentOrders.map((order) => {
                const [date, time] = order.orderdate.split(" - ");

                return (
                  <tr key={order.orderno}>
                    <td className="ps-3 fw-bold">{order.orderno}</td>

                    <td>{date}</td>
                    <td>{time}</td>

                    <td className="fw-bold">₹{order.amount}</td>

                    <td>
                      {order.isconfirmed === 1 ? (
                        <span className="text-success fs-4">
                          <i className="bi bi-check-circle-fill"></i>
                        </span>
                      ) : (
                        <span className="text-danger fs-4">
                          <i className="bi bi-x-circle-fill"></i>
                        </span>
                      )}
                    </td>

                    <td className="text-center pe-3">
                      <button
                        className="btn btn-success btn-sm px-4 rounded-pill fw-bold"
                        onClick={() =>
                          navigate("/order-details", {
                            state: { orderno: order.orderno },
                          })
                        }
                      >
                        VIEW ORDER
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-5">
                  <div className="mb-2 fs-1">📦</div>

                  <h5 className="fw-bold text-dark">
                    You haven’t placed any orders yet
                  </h5>

                  <p className="text-muted mb-3">
                    Discover designs and place your first order
                  </p>

                  <button
                    className="btn btn-primary px-4 rounded-pill fw-bold"
                    onClick={() => navigate("/designes")}
                  >
                    Browse Designs
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {totalPages > 1 && (
          <div className="pagination-container d-flex justify-content-center mt-4">
            <ul className="pagination custom-pagination">
              {/* Prev */}
              <li className={`page-item ${safePage === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => goToPage(safePage - 1)}
                >
                  Prev
                </button>
              </li>

              {/* Page Numbers */}
              {getPagination().map((page, index) =>
                page === "..." ? (
                  <li key={index} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                ) : (
                  <li
                    key={index}
                    className={`page-item ${safePage === page ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => goToPage(page)}
                    >
                      {page}
                    </button>
                  </li>
                ),
              )}

              {/* Next */}
              <li
                className={`page-item ${safePage === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => goToPage(safePage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
